module.exports = __webpack_public_path__ + "static/img/MY@2x.4023d2ac.jpg";